import { render, staticRenderFns } from "./CatchPraseForm.vue?vue&type=template&id=aaa3ff00&scoped=true&"
import script from "./CatchPraseForm.vue?vue&type=script&lang=js&"
export * from "./CatchPraseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa3ff00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
